import { Button } from 'primereact/button'
import { MouseEventHandler, PropsWithChildren, ReactNode } from 'react'
import { LoadingIcon } from '../Icons'
import { classNames } from 'primereact/utils'

type IconButtonProps = {
  title?: string
  type?: 'button' | 'submit' | 'reset' | undefined
  severity?: 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help' | undefined
  disabled?: boolean
  loading?: boolean
  clear?: boolean
  link?: boolean
  icon: ReactNode
  onClick?: MouseEventHandler<HTMLButtonElement>
  dataPrAt?: string
  additionalClassName?: string
  label?: string
}

const IconButton = ({ severity, type = "button", icon, title, disabled, clear, loading, link, onClick, dataPrAt, additionalClassName, label }: IconButtonProps & PropsWithChildren) => {
  const hasLabel = !!label
  const isHeaderActionButton = (additionalClassName || '').includes('header-action-button')

  return (
    <Button
      type={type}
      onClick={onClick}
      severity={severity}
      disabled={disabled}
      link={link}
      className={
        classNames(
          'icon-button cursor-pointer flex items-center justify-center gap-1 shrink-0',
          {
            '!bg-transparent': clear,
            '!cursor-not-allowed !opacity-50': disabled,
            '!px-3 !py-2 !min-w-max': hasLabel,
            '!h-auto': hasLabel,
            '!rounded-md': hasLabel
          }
        ) + (additionalClassName || '')}
      style={
        isHeaderActionButton
          ? {
              width: '36px',
              minWidth: '36px',
              height: '36px',
              minHeight: '36px',
              padding: '0',
              borderRadius: '6px'
            }
          : undefined
      }
      tooltip={title}
      tooltipOptions={{ position: 'bottom', showDelay: 150 }}
      data-pr-at={dataPrAt || 'center bottom'}
    >
      {loading && <LoadingIcon className="w-4 h-4 fill-white animate-spin" />}
      {!loading && icon}
      {label && <span className={hasLabel ? 'whitespace-nowrap' : 'mt-1'}>{label}</span>}
    </Button>
  )
}

export default IconButton
